import { AxiosInstance } from "axios";
import { sessionUrl, sessionVaultUrl, userIdUrl } from "../helpers/urlHelper";
import { IPrimitiveType } from "../interfaces/mfiles/IPrimitiveType";
import { ISessionInfo } from "../interfaces/mfiles/ISessionInfo";
import { IVault } from "../interfaces/mfiles/IVault";

export const getUserIdAsync = async (httpClient: AxiosInstance): Promise<number> => {
  const url = userIdUrl();
  const response = await httpClient.get<IPrimitiveType<number>>(url);
  return response.data?.Value;
};

export const getSessionAsync = async (httpClient: AxiosInstance): Promise<ISessionInfo> => {
  const url = sessionUrl();
  const response = await httpClient.get<ISessionInfo>(url);
  return response.data;
};

export const getSessionVaultAsync = async (httpClient: AxiosInstance): Promise<IVault> => {
  const url = sessionVaultUrl();
  const response = await httpClient.get<IVault>(url);
  return response.data;
};
